import React from 'react';
import { withHTTP } from '../../../helpers/utils';

export const HeartIcon = ({ color = '#F93C10', ...other }) => (
  <svg
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <path
      d="M26 8.11124C26 3.63181 22.5593 0 18.3149 0C16.2514 0 14.3796 0.859538 12.9996 2.25648C11.6192 0.859538 9.74803 0 7.68625 0C3.44095 0 0 3.63181 0 8.11156C0 10.5219 0.998824 12.6866 2.58227 14.1734L11.126 23.1893C11.6186 23.7114 12.2766 24 12.9788 24C13.0043 24 13.0316 24 13.0566 24C13.7558 24 14.4129 23.7136 14.9072 23.1931L23.619 13.997C23.676 13.9372 23.7301 13.8732 23.7806 13.8096C25.1526 12.3438 26 10.3311 26 8.11124Z"
      fill={color}
    />
  </svg>
);

export const SmallHeartIcon = ({ color = '#F93C10', ...other }) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <path
      d="M10 18.35L8.55 17.035C3.4 12.36 0 9.275 0 5.5C0 2.415 2.415 0 5.5 0C7.24 0 8.91 0.81 10 2.085C11.09 0.81 12.76 0 14.5 0C17.585 0 20 2.415 20 5.5C20 9.275 16.6 12.36 11.45 17.035L10 18.35Z"
      fill={color}
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 -6.10352e-05C7.34542 -6.10352e-05 6.81482 0.530576 6.81482 1.18512V6.81475H1.18519C0.530637 6.81475 0 7.34536 0 7.99994C0 8.65452 0.530637 9.18512 1.18519 9.18512H6.81482V14.8148C6.81482 15.4693 7.34542 16 8 16C8.65458 16 9.18519 15.4693 9.18519 14.8148V9.18512H14.8148C15.4694 9.18512 16 8.65452 16 7.99994C16 7.34536 15.4694 6.81475 14.8148 6.81475H9.18519V1.18512C9.18519 0.530576 8.65458 -6.10352e-05 8 -6.10352e-05Z"
      fill="black"
    />
  </svg>
);

export const ArrowUp = ({ ...other }) => (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.78144 0.32L13.6766 6.10667C14.1078 6.56 14.1078 7.25333 13.6766 7.68C13.2455 8.10667 12.518 8.10667 12.0868 7.68L7 2.66667L1.91317 7.68C1.45509 8.10667 0.754491 8.10667 0.323353 7.68C-0.107784 7.25333 -0.107784 6.56 0.323353 6.10667L6.19162 0.32C6.6497 -0.106667 7.3503 -0.106667 7.78144 0.32Z"
      fill="black"
    />
  </svg>
);

export const ArrowLongNext = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4421 0.217336C10.3883 0.152843 10.3216 0.100263 10.2463 0.0629492C10.1711 0.0256355 10.0889 0.00440673 10.005 0.000616153C9.92103 -0.00317443 9.83724 0.0105564 9.75893 0.0409333C9.68061 0.0713101 9.60948 0.117667 9.55008 0.177047C9.49068 0.236428 9.4443 0.30753 9.41392 0.38582C9.38353 0.46411 9.36979 0.54787 9.37358 0.631761C9.37738 0.715653 9.39861 0.797834 9.43594 0.873065C9.47327 0.948297 9.52587 1.01493 9.59038 1.06871L13.9356 5.41754H0.573292C0.418245 5.42576 0.272261 5.49312 0.165421 5.60574C0.0585803 5.71836 -0.000976562 5.86765 -0.000976562 6.02286C-0.000976562 6.17807 0.0585803 6.32737 0.165421 6.43999C0.272261 6.55261 0.418245 6.61997 0.573292 6.62819H13.9356L9.58357 10.9719C9.47403 11.0866 9.41291 11.239 9.41291 11.3976C9.41291 11.5562 9.47403 11.7086 9.58357 11.8233C9.63943 11.8793 9.7058 11.9237 9.77887 11.9541C9.85195 11.9844 9.93029 12 10.0094 12C10.0885 12 10.1669 11.9844 10.2399 11.9541C10.313 11.9237 10.3794 11.8793 10.4352 11.8233L15.8179 6.44259C15.8751 6.38747 15.9207 6.32135 15.9519 6.24821C15.983 6.17506 15.999 6.09639 15.999 6.0169C15.999 5.93742 15.983 5.85874 15.9519 5.7856C15.9207 5.71245 15.8751 5.64634 15.8179 5.59122L10.4421 0.217336Z"
      fill="black"
    />
  </svg>
);

export const WarningIcon = ({ ...other }) => (
  <svg
    width="20"
    height="20"
    style={{ minHeight: '20px', minWidth: '20px' }}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <rect width="20" height="20" rx="10" fill="#F93C10" />
    <path
      d="M9.204 11.878V5.2H10.73V11.878H9.204ZM10.8 14.762C10.5667 14.9953 10.2867 15.112 9.96 15.112C9.63333 15.112 9.35333 14.9953 9.12 14.762C8.896 14.5287 8.784 14.2487 8.784 13.922C8.784 13.5953 8.896 13.32 9.12 13.096C9.35333 12.8627 9.63333 12.746 9.96 12.746C10.2867 12.746 10.5667 12.8627 10.8 13.096C11.0333 13.32 11.15 13.5953 11.15 13.922C11.15 14.2487 11.0333 14.5287 10.8 14.762Z"
      fill="white"
    />
  </svg>
);

export const InfoIcon = props => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="19"
      height="19"
      rx="9.5"
      fill="white"
      stroke="#9E98A3"
    />
    <path
      d="M9.204 11.878V5.2H10.73V11.878H9.204ZM10.8 14.762C10.5667 14.9953 10.2867 15.112 9.96 15.112C9.63333 15.112 9.35333 14.9953 9.12 14.762C8.896 14.5287 8.784 14.2487 8.784 13.922C8.784 13.5953 8.896 13.32 9.12 13.096C9.35333 12.8627 9.63333 12.746 9.96 12.746C10.2867 12.746 10.5667 12.8627 10.8 13.096C11.0333 13.32 11.15 13.5953 11.15 13.922C11.15 14.2487 11.0333 14.5287 10.8 14.762Z"
      fill="#9E98A3"
    />
  </svg>
);

export const SuccessIcon = ({ ...other }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...other}
  >
    <rect width="20" height="20" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_1192_325" transform="scale(0.00420168)" />
      </pattern>
      <image
        id="image0_1192_325"
        width="238"
        height="238"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const SpecTriangleIcon = ({ ...other }) => (
  <svg
    width="14"
    height="28"
    viewBox="0 0 14 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-6.11959e-07 14C7.73199 14 14 20.268 14 28L14 -6.11959e-07C14 7.73199 7.73199 14 -6.11959e-07 14Z"
      fill="white"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="7" stroke="black" strokeWidth="2" />
    <path
      d="M12.7071 13.4141L13.4142 12.707L18.3965 17.6893C18.5918 17.8845 18.5918 18.2011 18.3965 18.3964C18.2013 18.5916 17.8847 18.5916 17.6894 18.3964L12.7071 13.4141Z"
      fill="#9E98A3"
      stroke="black"
    />
  </svg>
);

export const XIcon = ({ ...other }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <path
      d="M11.3434 2.372L7.53541 6.18L11.3154 9.988L9.77541 11.528L5.99541 7.72L2.21541 11.5L0.675406 9.988L4.45541 6.18L0.675406 2.4L2.18741 0.86L5.99541 4.64L9.80341 0.86L11.3434 2.372Z"
      fill="black"
    />
  </svg>
);

export const RotateIcon = ({ onClick, className }) => (
  <svg
    className={className}
    onClick={onClick}
    width="28"
    height="36"
    viewBox="0 0 28 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d)">
      <path
        d="M20.0232 8.30232L12.1279 16.0349V9.27907C9.68604 9.71318 7.63759 10.8934 5.98256 12.8198C4.32752 14.7461 3.5 16.9845 3.5 19.5349C3.5 22.0853 4.32752 24.3236 5.98256 26.25C7.63759 28.1764 9.68604 29.3566 12.1279 29.7907V33.2907C8.7093 32.8566 5.83333 31.3372 3.5 28.7326C1.16667 26.1279 0 23.062 0 19.5349C0 16.0078 1.16667 12.9419 3.5 10.3372C5.83333 7.73256 8.7093 6.21318 12.1279 5.77907V0.406975L20.0232 8.30232ZM27.6744 17.8256H24.1744C23.9031 16.2519 23.3062 14.814 22.3837 13.5116L24.8256 11.0698C26.3992 13.0775 27.3488 15.3295 27.6744 17.8256ZM15.6279 29.7907C17.1473 29.5194 18.5581 28.9225 19.8605 28L22.3837 30.5233C20.376 32.0426 18.124 32.9651 15.6279 33.2907V29.7907ZM22.3837 25.5581C23.3062 24.2558 23.9031 22.8178 24.1744 21.2442H27.6744C27.3488 23.7403 26.3992 25.9922 24.8256 28L22.3837 25.5581Z"
        fill="#FDFBFB"
      />
      <path
        d="M12.1904 0.557863L19.9344 8.30186L12.1904 15.8862V9.27907V9.20448L12.117 9.21753C9.66055 9.65423 7.59934 10.842 5.93515 12.779C4.27033 14.7168 3.4375 16.9696 3.4375 19.5349C3.4375 22.1001 4.27033 24.353 5.93515 26.2907C7.58768 28.2142 9.63169 29.3989 12.0654 29.8429V33.2196C8.69285 32.7756 5.85398 31.2666 3.54655 28.6909C1.22359 26.0978 0.0625 23.0468 0.0625 19.5349C0.0625 16.023 1.22359 12.972 3.54655 10.3789C5.87001 7.78528 8.73233 6.27325 12.1358 5.84107L12.1904 5.83413V5.77907V0.557863ZM22.4651 13.5186L24.8198 11.164C26.3459 13.1299 27.2735 15.3293 27.6031 17.7631H24.2269C23.953 16.2178 23.3656 14.8028 22.4651 13.5186ZM15.6904 33.2193V29.8429C17.1828 29.5688 18.5706 28.9814 19.8535 28.0814L22.2887 30.5166C20.3231 31.9895 18.1239 32.8903 15.6904 33.2193ZM24.8198 27.9058L22.4651 25.5511C23.3656 24.267 23.953 22.8519 24.2269 21.3067H27.6031C27.2735 23.7404 26.3459 25.9398 24.8198 27.9058Z"
        stroke="black"
        strokeWidth="0.125"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="-1"
        y="0.406975"
        width="29.6744"
        height="34.8837"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const FacebookIcon = ({ href }) => (
  <a
    href={withHTTP(href)}
    target="_blank"
    rel="noopener noreferrer"
    className="facebook"
    style={{ display: 'inline-block' }}
  >
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          d="M28 14.0853C28 6.30537 21.7328 0 14 0C6.26719 0 0 6.30537 0 14.0853C0 21.1169 5.11875 26.9436 11.8125 28V18.1568H8.25781V14.0853H11.8125V10.9821C11.8125 7.45255 13.9016 5.50206 17.1008 5.50206C18.632 5.50206 20.2344 5.77717 20.2344 5.77717V9.24347H18.468C16.7289 9.24347 16.1875 10.3301 16.1875 11.4443V14.0853H20.0703L19.4496 18.1568H16.1875V28C22.8813 26.9436 28 21.1169 28 14.0853Z"
          fill="#9E98A3"
        />
      </g>
    </svg>
  </a>
);

export const LinkedInIcon = ({ href }) => (
  <a
    href={withHTTP(href)}
    target="_blank"
    rel="noopener noreferrer"
    className="linkedin"
    style={{ display: 'inline-block' }}
  >
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0ZM6.73568 11.5978H9.90838V21.1305H6.73568V11.5978ZM10.1044 8.64657C10.0838 7.7119 9.41545 7 8.33009 7C7.24473 7 6.53516 7.7119 6.53516 8.64657C6.53516 9.56189 7.22376 10.2943 8.28891 10.2943H8.30918C9.41545 10.2943 10.1044 9.56189 10.1044 8.64657ZM17.6722 11.3709C19.76 11.3709 21.3252 12.7337 21.3252 15.6617L21.325 21.1275H18.1525V16.0275C18.1525 14.7465 17.6933 13.8723 16.5448 13.8723C15.6683 13.8723 15.1462 14.4616 14.9169 15.0308C14.833 15.2348 14.8124 15.519 14.8124 15.8039V21.1277H11.6393C11.6393 21.1277 11.6811 12.4895 11.6393 11.595H14.8124V12.9453C15.2335 12.2962 15.9877 11.3709 17.6722 11.3709Z"
          fill="#9E98A3"
        />
      </g>
    </svg>
  </a>
);

export const TwitterIcon = ({ href }) => (
  <a
    href={withHTTP(href)}
    target="_blank"
    rel="noopener noreferrer"
    className="linkedin"
    style={{ display: 'inline-block' }}
  >
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
          fill="#9E98A3"
        />
        <path
          d="M22.1572 10.7342C22.1682 10.897 22.1682 11.0597 22.1682 11.2239C22.1682 16.2284 18.4534 22 11.6607 22V21.997C9.65411 22 7.68921 21.4105 6 20.2991C6.29177 20.3351 6.58501 20.3531 6.87898 20.3539C8.54186 20.3554 10.1572 19.7831 11.4654 18.7295C9.88519 18.6987 8.49945 17.642 8.01536 16.0994C8.56892 16.2089 9.13931 16.1864 9.68263 16.0341C7.95978 15.6771 6.72029 14.1247 6.72029 12.3219C6.72029 12.3054 6.72029 12.2896 6.72029 12.2739C7.23364 12.5671 7.80841 12.7298 8.39634 12.7478C6.77367 11.6357 6.27349 9.42179 7.25338 7.6909C9.12834 10.057 11.8947 11.4954 14.8644 11.6477C14.5667 10.3322 14.9733 8.95382 15.9327 8.02913C17.4201 6.59522 19.7594 6.66872 21.1576 8.19337C21.9846 8.02613 22.7773 7.7149 23.5027 7.27393C23.2271 8.15062 22.6501 8.89533 21.8793 9.36855C22.6113 9.28005 23.3265 9.07907 24 8.77234C23.5042 9.53429 22.8797 10.198 22.1572 10.7342Z"
          fill="white"
        />
      </g>
    </svg>
  </a>
);

export const DocumentIcon = () => (
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.8623 15.3994H10.1221C11.5371 15.3994 12.2412 14.6816 12.2412 13.2598V7.05273C12.2412 6.1709 12.1387 5.78809 11.5918 5.22754L7.8252 1.39258C7.30566 0.859375 6.875 0.743164 6.10938 0.743164H2.8623C1.4541 0.743164 0.743164 1.46777 0.743164 2.88965V13.2598C0.743164 14.6885 1.44727 15.3994 2.8623 15.3994ZM2.91016 14.2988C2.20605 14.2988 1.84375 13.9229 1.84375 13.2393V2.91016C1.84375 2.2334 2.20605 1.84375 2.91699 1.84375H5.95898V5.81543C5.95898 6.67676 6.38965 7.10059 7.24414 7.10059H11.1406V13.2393C11.1406 13.9229 10.7783 14.2988 10.0674 14.2988H2.91016ZM7.36719 6.06836C7.09375 6.06836 6.99121 5.95898 6.99121 5.68555V2.05566L10.9287 6.06836H7.36719ZM9.00781 8.98047H3.81934C3.57324 8.98047 3.38867 9.16504 3.38867 9.39746C3.38867 9.63672 3.57324 9.82129 3.81934 9.82129H9.00781C9.24707 9.82129 9.4248 9.63672 9.4248 9.39746C9.4248 9.16504 9.24707 8.98047 9.00781 8.98047ZM9.00781 11.3662H3.81934C3.57324 11.3662 3.38867 11.5576 3.38867 11.7969C3.38867 12.0293 3.57324 12.207 3.81934 12.207H9.00781C9.24707 12.207 9.4248 12.0293 9.4248 11.7969C9.4248 11.5576 9.24707 11.3662 9.00781 11.3662Z"
      fill="black"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99926 9.41609L14.2902 15.7072C14.6811 16.0982 15.3163 16.097 15.7063 15.7072C16.097 15.3163 16.0972 14.6821 15.706 14.2911L9.41537 8.00023L15.7063 1.70932C16.097 1.31837 16.097 0.68392 15.7063 0.293212C15.3153 -0.0977374 14.6811 -0.0977374 14.2902 0.293212L7.99926 6.58412L1.70835 0.293212C1.3174 -0.0977374 0.683197 -0.0977374 0.292489 0.293212C0.0970138 0.488687 0.000482931 0.744011 0.000724258 1.00078C2.77177e-07 1.25804 0.0970138 1.51384 0.292489 1.70932L6.5834 8.00023L0.293212 14.2902C0.0977376 14.4859 -0.000240882 14.7422 4.44708e-07 14.9985C0.000483098 15.255 0.0977377 15.511 0.292971 15.7065C0.683679 16.0972 1.31813 16.0975 1.70908 15.7065L7.99926 9.41609Z"
      fill="#9E98A3"
    />
  </svg>
);

export const CloseMobileIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0C5.36 0 0 5.36 0 12C0 18.64 5.36 24 12 24C18.64 24 24 18.64 24 12C24 5.36 18.64 0 12 0ZM15.4667 17.0667C14.32 15.92 13.1467 14.7467 12 13.6C10.8533 14.7467 9.68 15.92 8.53333 17.0667C7.49333 18.1067 5.92 16.5067 6.93333 15.4667C8.08 14.32 9.25333 13.1467 10.4 12C9.25333 10.8533 8.08 9.68 6.93333 8.53333C5.89333 7.49333 7.49333 5.92 8.53333 6.93333C9.68 8.08 10.8533 9.25333 12 10.4C13.1467 9.25333 14.32 8.08 15.4667 6.93333C16.5067 5.89333 18.08 7.49333 17.0667 8.53333C15.92 9.68 14.7467 10.8533 13.6 12C14.7467 13.1467 15.92 14.32 17.0667 15.4667C18.08 16.48 16.48 18.08 15.4667 17.0667Z"
      fill="#9E98A3"
    />
  </svg>
);

export const TooltipIcon = props => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="19"
      height="19"
      rx="9.5"
      fill="white"
      stroke="#9E98A3"
    />
    <path
      d="M8.872 11.324V11.192C8.872 10.792 8.916 10.476 9.004 10.244C9.1 10.012 9.312 9.776 9.64 9.536L10.192 9.128C10.696 8.76 10.948 8.3 10.948 7.748C10.948 7.396 10.844 7.116 10.636 6.908C10.436 6.7 10.168 6.596 9.832 6.596C9.408 6.596 9.068 6.72 8.812 6.968C8.564 7.216 8.44 7.584 8.44 8.072H7.06C7.06 7.224 7.312 6.568 7.816 6.104C8.32 5.632 9.012 5.396 9.892 5.396C10.668 5.396 11.276 5.608 11.716 6.032C12.156 6.456 12.376 7.012 12.376 7.7C12.376 8.18 12.272 8.584 12.064 8.912C11.856 9.24 11.544 9.568 11.128 9.896L10.696 10.232C10.488 10.392 10.348 10.536 10.276 10.664C10.212 10.792 10.18 10.956 10.18 11.156V11.324H8.872ZM10.24 13.796C10.04 13.996 9.8 14.096 9.52 14.096C9.24 14.096 9 13.996 8.8 13.796C8.608 13.596 8.512 13.356 8.512 13.076C8.512 12.796 8.608 12.56 8.8 12.368C9 12.168 9.24 12.068 9.52 12.068C9.8 12.068 10.04 12.168 10.24 12.368C10.44 12.56 10.54 12.796 10.54 13.076C10.54 13.356 10.44 13.596 10.24 13.796Z"
      fill="#9E98A3"
    />
  </svg>
);
